'use client';

import Link from 'next/link';

import { Button } from '@/components/ui/button';
import CheckIcon from '@/components/icons/check';

const ACCEPTED_TITLE = 'Ваше заявление на подключение принято';
const ACCEPTED_DESCRIPTION = 'Вы можете перейти к настройкам продаж в конкретной работе';
const ACCEPTED_BUTTON_LABEL = 'Перейти';
const AUTHOR_DASHBOARD_HREF = '/author-dashboard';

export const SaleConnectionAccepted = () => {
  return (
    <div className="mx-auto bg-white rounded-xl p-6 md:py-8 md:px-6 flex flex-col items-center justify-center text-center space-y-6 max-w-[463px]">
      <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-[#F1F2FF]">
        <CheckIcon className="h-6 w-6 text-[#505CFF]" />
      </div>

      <div className="space-y-3">
        <h3 className="text-xl font-bold text-[#1B1D22] leading-[1.25]">{ACCEPTED_TITLE}</h3>
        <p className="text-base text-[#6C7286]">{ACCEPTED_DESCRIPTION}</p>
      </div>

      <Button
        asChild
        variant="purple"
        className="w-full max-w-[165px] h-10 rounded-xl bg-[#505CFF] hover:bg-[#505CFF]/90 text-white font-medium"
      >
        <Link href={AUTHOR_DASHBOARD_HREF}>{ACCEPTED_BUTTON_LABEL}</Link>
      </Button>
    </div>
  );
};
